// GamePassDirect — ES module (defer natif). Utilitaires partagés ; chaque section ajoute son propre module si besoin.
const root = document.documentElement;
root.classList.add('vyrl-js');

export const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Appelle cb(el) une seule fois quand el entre dans le viewport (IntersectionObserver). */
export function onVisible(elements, cb, options = { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }) {
  const list = Array.from(elements);
  if (!list.length) return;
  if (!('IntersectionObserver' in window) || prefersReducedMotion()) {
    list.forEach(cb);
    return;
  }
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      io.unobserve(entry.target);
      cb(entry.target);
    }
  }, options);
  list.forEach((el) => io.observe(el));
}

// will-change n'est posé que pendant l'anim : .is-done le retire (transitionend, avec filet de sécurité).
function reveal(el) {
  el.classList.add('is-in');
  const done = () => el.classList.add('is-done');
  el.addEventListener('transitionend', done, { once: true });
  setTimeout(done, 1200);
}

function initReveal(scope = document) {
  onVisible(scope.querySelectorAll('.vyrl-reveal:not(.is-in)'), reveal);
}

initReveal();
// Animations décoratives : démarrées après le chargement (voir vyrl.css), jamais pendant le premier rendu.
const startAnimations = () => root.classList.add('vyrl-anim');
const afterLoad = () => ('requestIdleCallback' in window ? requestIdleCallback(startAnimations, { timeout: 4000 }) : setTimeout(startAnimations, 2000));
if (document.readyState === 'complete') afterLoad();
else window.addEventListener('load', afterLoad, { once: true });
import('./vyrl-cta.js'); // CTA d'achat : état de redirection + repli (aussi avec reduced-motion)
// Effets 3D (tilt, parallax) : jamais chargés si l'utilisateur demande moins de mouvement.
if (!prefersReducedMotion()) import('./vyrl-fx.js');
// Theme Editor : réinitialiser quand une section est rechargée.
document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
